import React from 'react';
import { motion } from 'framer-motion';

const PlatformPreviews = ({ content, platforms }) => {
  const platformIcons = {
    facebook: '\ud83d\udc65',
    instagram: '\ud83d\udcf8',
    linkedin: '\ud83d\udcbc',
    x: '\u2716\ufe0f',
    tiktok: '\ud83c\udfb5',
    youtube: '\u25b6\ufe0f'
  };

  return (
    <div className="space-y-4">
      {platforms.map((platform) => {
        const icon = platformIcons[platform.id];

        return (
          <motion.div
            key={platform.id}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="bg-white/5 backdrop-blur-xl rounded-2xl border border-white/10 p-6"
          >
            <div className="flex items-center gap-3 mb-4">
              <span className="text-2xl">{icon}</span>
              <h4 className="text-white font-semibold text-lg">{platform.name}</h4>
            </div>

            <div className="bg-white/5 rounded-xl p-4 min-h-32">
              <p className="text-slate-300 whitespace-pre-wrap">{content || 'Le contenu appara\u00eetra ici...'}</p>
            </div>
          </motion.div>
        );
      })}
    </div>
  );
};

export default PlatformPreviews;
